import request, { METHODS } from "src/utils/api-base";

const paymentApis = {
  getSettings: () =>
    request({ route: "/app/payments/settings", method: METHODS.GET, auth: true }),

  saveGateway: (provider: string, values: Record<string, string>) =>
    request({
      route: `/app/payments/settings/gateways/${provider}`,
      method: METHODS.PUT,
      payload: { values },
      auth: true,
    }),

  disconnectGateway: (provider: string) =>
    request({
      route: `/app/payments/settings/gateways/${provider}`,
      method: METHODS.DELETE,
      auth: true,
    }),

  savePreferences: (payload: { linkExpiryMinutes: number }) =>
    request({
      route: "/app/payments/settings/preferences",
      method: METHODS.PUT,
      payload,
      auth: true,
    }),

  getGatewayStatus: () =>
    request({ route: "/app/payments/gateway-status", method: METHODS.GET, auth: true }),

  getOrderPayments: (orderId: string) =>
    request({
      route: `/app/payments/sale-order/${orderId}`,
      method: METHODS.GET,
      auth: true,
    }),

  createCheckout: (orderId: string, payload: { amount: number }) =>
    request({
      route: `/app/payments/sale-order/${orderId}/checkout`,
      method: METHODS.POST,
      payload,
      auth: true,
    }),

  confirmCheckout: (
    checkoutId: string,
    payload: { providerPaymentId: string; providerOrderId: string; signature: string }
  ) =>
    request({
      route: `/app/payments/checkout/${checkoutId}/confirm`,
      method: METHODS.POST,
      payload,
      auth: true,
    }),

  recordPayment: (
    orderId: string,
    payload: {
      amount: number;
      // Defaults to cash on the server.
      method?: string;
      referenceNo?: string;
      remarks?: string;
      paidAt?: string;
    }
  ) =>
    request({
      route: `/app/payments/sale-order/${orderId}/record`,
      method: METHODS.POST,
      payload,
      auth: true,
    }),

  // Refund what's still owed on a cancelled order (also retries failed
  // gateway refunds).
  refundOrder: (orderId: string, payload: { offlineRefunded: boolean }) =>
    request({
      route: `/app/payments/sale-order/${orderId}/refund`,
      method: METHODS.POST,
      payload,
      auth: true,
    }),

  createPaymentLink: (
    orderId: string,
    payload: { amount: number; allowPartial: boolean; minPartialAmount?: number }
  ) =>
    request({
      route: `/app/payments/sale-order/${orderId}/link`,
      method: METHODS.POST,
      payload,
      auth: true,
    }),

  getPaymentLink: (linkId: string) =>
    request({ route: `/app/payments/links/${linkId}`, method: METHODS.GET, auth: true }),

  cancelPaymentLink: (linkId: string) =>
    request({
      route: `/app/payments/links/${linkId}/cancel`,
      method: METHODS.POST,
      auth: true,
    }),

  notifyPaymentLink: (linkId: string, channel: "sms" | "email") =>
    request({
      route: `/app/payments/links/${linkId}/notify`,
      method: METHODS.POST,
      payload: { channel },
      auth: true,
    }),

  getPaymentsList: (params: {
    page: number;
    limit: number;
    search?: string;
    method?: string;
    via?: string;
    source?: string;
    status?: string;
    from?: string;
    to?: string;
  }) =>
    request({ route: "/app/payments/list", method: METHODS.GET, params, auth: true }),

  getSummary: () =>
    request({ route: "/app/payments/summary", method: METHODS.GET, auth: true }),
};

export default paymentApis;
